import { render, staticRenderFns } from "./duihuanlist.vue?vue&type=template&id=fffbaaea&scoped=true&"
import script from "./duihuanlist.vue?vue&type=script&lang=js&"
export * from "./duihuanlist.vue?vue&type=script&lang=js&"
import style0 from "./duihuanlist.vue?vue&type=style&index=0&id=fffbaaea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffbaaea",
  null
  
)

export default component.exports